<template>
  <div class="flex flex-col p-3">

    <AppModal v-model="showNewService" title="New Service" hide-footer>
      <div class="space-y-3">
        <input type="text"
               class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary text-sm"
               v-model="form.serviceName" placeholder="Service Name" />
        <input type="text"
               class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary text-sm"
               v-model="form.serviceCode" placeholder="Service Code" />
        <input type="number"
               class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary text-sm"
               v-model="form.serviceCost" placeholder="Service Cost" />
        <select v-model="form.taxHeadId"
                class="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary bg-white">
          <option value="" disabled selected>Select Tax Head</option>
          <option v-for="(item, idx) in taxHeads" :key="idx" :value="item.id">{{ item.taxHeadCode }}</option>
        </select>
        <select v-model="form.currencyId"
                class="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary bg-white">
          <option value="" disabled selected>Select Currency</option>
          <option v-for="(item, idx) in currencies" :key="idx" :value="item.id">{{ item.code }} - {{
              item.name
            }}
          </option>
        </select>
        <div class="flex justify-end">
          <button class="btn-primary" @click="save">
            <i class="fa fa-save mr-1"></i> Save
          </button>
        </div>
      </div>
    </AppModal>

    <AppModal v-model="showEditService" title="Edit Service" hide-footer>
      <div class="space-y-3">
        <input type="text"
               class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary text-sm"
               v-model="editForm.serviceName" placeholder="Service Name" />
        <input type="text"
               class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary text-sm"
               v-model="editForm.serviceCode" placeholder="Service Code" />
        <input type="number"
               class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary text-sm"
               v-model="editForm.serviceCost" placeholder="Service Cost" />
        <select v-model="editForm.taxHeadId"
                class="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary bg-white">
          <option value="" disabled selected>Select Tax Head</option>
          <option v-for="(item, idx) in taxHeads" :key="idx" :value="item.id">{{ item.taxHeadCode }}</option>
        </select>
        <select v-model="editForm.currencyId"
                class="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary bg-white">
          <option value="" disabled selected>Select Currency</option>
          <option v-for="(item, idx) in currencies" :key="idx" :value="item.id">{{ item.code }} - {{
              item.name
            }}
          </option>
        </select>
        <div class="flex justify-end">
          <button class="btn-primary" @click="updateServiceCost">
            <i class="fa fa-pencil mr-1"></i> Save Changes
          </button>
        </div>
      </div>
    </AppModal>

    <!-- Header -->
    <div class="flex items-center justify-between py-3">
      <input
        type="text"
        v-model="search"
        class="px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary text-sm w-64"
        placeholder="Search by name"
        @keyup.enter="searchServices"
      />
      <button v-if="canViewMenuItem('can_create_service_costs')" class="btn-primary" @click="showNewService = true">
        <i class="fa fa-plus mr-1"></i> Add Service
      </button>
    </div>

    <!-- Table -->
    <div>
      <table>
        <thead>
        <tr>
          <th>#</th>
          <th>Name</th>
          <th>Tax Head</th>
          <th>Code</th>
          <th>Cost</th>
          <th>Action</th>
        </tr>
        </thead>
        <tbody>
        <template v-if="loading">
          <tr v-for="i in 5" :key="`sk-${i}`" class="animate-pulse">
            <td>
              <div class="h-3 bg-gray-200 rounded w-6"></div>
            </td>
            <td>
              <div class="h-3 bg-gray-200 rounded w-40"></div>
            </td>
            <td>
              <div class="h-3 bg-gray-200 rounded w-20"></div>
            </td>
            <td>
              <div class="h-3 bg-gray-200 rounded w-20"></div>
            </td>
            <td>
              <div class="h-3 bg-gray-200 rounded w-16"></div>
            </td>
            <td>
              <div class="h-3 bg-gray-200 rounded w-20"></div>
            </td>
          </tr>
        </template>
        <template v-else>
          <tr v-for="(service, idx) in serviceCosts" :key="service.id">
            <td>{{ idx + 1 }}</td>
            <td class="font-bold">{{ service.serviceName.replaceAll("_", " ").toLowerCase() }}</td>
            <td>{{ service.taxHeadCode }}</td>
            <td>{{ service.serviceCode }}</td>
            <td class="font-medium">UGX {{ service.serviceCost?.toLocaleString() }}</td>
            <td>
              <div class="flex gap-1">
                <button v-if="canViewMenuItem('can_modify_service_costs')" class="btn-sm-primary"
                        @click="openEdit(service)"><i class="fa fa-edit mr-1"></i>Edit
                </button>
                <button v-if="canViewMenuItem('can_modify_service_costs')" class="btn-sm-danger"
                        @click="deleteService(service.id)"><i class="fa fa-trash mr-1"></i>Delete
                </button>
              </div>
            </td>
          </tr>
        </template>
        <tr v-if="!loading && serviceCosts.length === 0">
          <td colspan="6" class="text-center py-6 text-gray-400 text-sm">No results found</td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted, ref, watch } from "vue";
import { useAbility } from "@casl/vue";
import AppModal from "@/components/ui/AppModal.vue";
import { useBillingStore } from "@/domains/home/services/billing/stores";

const billingStore = useBillingStore();
const { can } = useAbility();

const showNewService = ref(false);
const showEditService = ref(false);
const loading = ref(false);
const search = ref("");
const serviceCosts = ref<any[]>([]);
const currencies = ref<any[]>([]);
const taxHeads = ref<any[]>([]);

const form = ref({
  serviceName: null as string | null,
  serviceCost: null as number | null,
  serviceCode: null as string | null,
  taxHeadId: null as string | null,
  currencyId: null as string | null
});
const editForm = ref({
  serviceChargeId: null as string | null,
  serviceName: null as string | null,
  serviceCost: null as number | null,
  serviceCode: null as string | null,
  taxHeadId: null as string | null,
  currencyId: null as string | null
});

const canViewMenuItem = (permission: string) => can(permission, "general");

const allServiceCosts = ref<any[]>([]);

const searchServices = () => {
  if (!search.value.trim()) {
    serviceCosts.value = allServiceCosts.value;
    return;
  }
  const q = search.value.toLowerCase();
  serviceCosts.value = allServiceCosts.value.filter(s =>
    s.serviceName?.toLowerCase().includes(q) || s.serviceCode?.toLowerCase().includes(q)
  );
};

onMounted(() => {
  loading.value = true;
  billingStore.fetchServiceCosts();
  billingStore.fetchCurrencies();
  billingStore.fetchTaxHeads();
});

const save = () => {
  billingStore.createServiceCost(form.value);
};

const openEdit = (data: any) => {
  editForm.value = {
    serviceChargeId: data.id,
    serviceName: data.serviceName,
    serviceCost: data.serviceCost,
    serviceCode: data.serviceCode,
    taxHeadId: data.taxHeadId,
    currencyId: data.currencyId
  };
  showEditService.value = true;
};

const updateServiceCost = () => {
  loading.value = true;
  billingStore.editServiceCost(editForm.value);
};

const deleteService = (id: string) => {
  loading.value = true;
  billingStore.deleteServiceCost(id);
};

const resetForm = () => {
  form.value = { serviceName: null, serviceCost: null, serviceCode: null, taxHeadId: null, currencyId: null };
};

watch(() => billingStore.serviceCosts, (data) => {
  loading.value = false;
  const list = Array.isArray(data) ? data : (data?.data ?? []);
  serviceCosts.value = list;
  allServiceCosts.value = list;
});

watch(() => billingStore.currencies, (data) => {
  if (data?.data) currencies.value = data.data;
  else if (Array.isArray(data)) currencies.value = data;
});

watch(() => billingStore.taxHeads, (data) => {
  if (Array.isArray(data)) taxHeads.value = data;
  else if (data?.data) taxHeads.value = data.data;
});

watch(() => billingStore.serviceCost, (data) => {
  if (data) {
    resetForm();
    showNewService.value = false;
    loading.value = true;
    billingStore.fetchServiceCosts();
  }
});

watch(() => billingStore.editServiceCostResult, (data) => {
  if (data) {
    showEditService.value = false;
    loading.value = true;
    billingStore.fetchServiceCosts();
  }
});

watch(() => billingStore.deleteServiceCostResult, (data) => {
  if (data) {
    loading.value = true;
    billingStore.fetchServiceCosts();
  }
});

watch(() => billingStore.error, (data) => {
  if (data) loading.value = false;
});
</script>
